export default{
    data() {
        return {
            apis:{
                praise:'sh/praise/praise',//点赞和取消点赞
                total:'sh/praise/total',//点赞总数
                praised: 'sh/praise/praised',//判断当前用户是否点赞
            },
            total: 0,//点赞总数
            userKey: null,//用户主键
            praised:false,//判断用户是否已经点赞
        }
    },
    props:{
        bizType:null,
        bizKey:null,
    },
    mounted() {
        this.userKey = sessionStorage.getItem(this.$global.userKey);
        this.getTotal();
        this.checkPraised();
    },
    methods: {
        getTotal(){//获取点赞总数
            const me = this;
            if(!me.bizType || !me.bizKey){
                me.total = 0;
                return;
            }
            me.$post({
                url: me.apis.total,
                params:{
                    bizType: me.bizType,
                    bizKey: me.bizKey
                }
            }).then(rsp => {
                if(rsp.success){
                    me.total = rsp.retObj;
                }
            })
        },
        praise(){//点赞或取消点赞
            const me = this;
            if(!me.bizType || !me.bizKey){
                return;
            }
            if(!me.userKey){
                me.$message.error('请先登录');
                return;
            }
            me.$post({
                url: me.apis.praise,
                params:{
                    bizType: me.bizType,
                    bizKey: me.bizKey,
                    userKey: me.userKey
                }
            }).then(rsp => {
                if(rsp.success){
                    me.total = rsp.retObj;
                    me.checkPraised();
                }
            })
        },
        checkPraised(){//判断是否已经点赞
            const me = this;
            if(!me.bizType || !me.bizKey || !me.userKey){
                me.praised = false;
                return;
            }
            me.$post({
                url: me.apis.praised,
                params:{
                    bizType: me.bizType,
                    bizKey: me.bizKey,
                    userKey: me.userKey
                }
            }).then(rsp => {
                me.praised = rsp.success && rsp.retObj;
            })
        }
    },

}


// WEBPACK FOOTER //
// ./src/components/base/view/interact/cmps/praise/src/praise.js